import { on } from "@ngrx/store";
import {
  AuthLoginAction,
  AuthLogoutAction,
  UserAddedAction,
  UserDeletedAction,
  UserLoadedAction,
  UserUpdatedAction
} from "./user.actions";
import {EmptyStoreState} from "@core/store/store.state";

export const userReducer = [
  on(UserAddedAction, (state: any, action) => {
    return Object.assign({}, state, { users: [...state.users, action.user] });
  }),
  on(UserDeletedAction, (state: any, action) => {
    return Object.assign({}, state, { users: state.users.filter(user => user.id_utente !== action.user.id_utente) });
  }),
  on(UserUpdatedAction, (state: any, action) => {
    return Object.assign({}, state, { users: state.users.map(element => element.id_utente === action.user.id_utente ? { ...element, id_utente: action.user.id_utente, ruolo: action.user.ruolo, is_developer: action.user.is_developer, email: action.user.email } : element) });
  }),
  on(UserLoadedAction, (state: any, action) => {
    return Object.assign({}, state, { users: action.users });
  }),
  on(AuthLoginAction, (state: any, action) => {
    return Object.assign({}, state, { user: action.user });
  }),
  on(AuthLogoutAction, (state: any, action) => {
    return Object.assign({}, state, EmptyStoreState);
  })
];
